exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_addressTitle__2ANpw {\n  margin: 0;\n  font-weight: bold;\n  padding: 0 .7rem .7rem .7rem;\n  color: var(--f7-theme-color);\n  /* font-size: 0.8rem; */\n}\n\n.styles_address__vtH4I {\n  margin: 0;\n  padding: 0 .7rem;\n  /* font-size: 0.8rem; */\n}\n\n.styles_button__2Sl4n {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  color: var(--f7-stepper-button-text-color) !important;\n  /* font-size: 1rem; */\n}", ""]);

// Exports
exports.locals = {
	"addressTitle": "styles_addressTitle__2ANpw",
	"address": "styles_address__vtH4I",
	"button": "styles_button__2Sl4n"
};